var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#DE3F6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4855 6.1875H5.994C6.78881 6.26288 7.524 6.64931 8.06794 7.20563C9.198 8.35256 9.819 9.97088 11.2573 10.8242C12.2968 11.4412 13.7509 10.9367 14.2616 9.89381C14.5215 9.88931 14.7831 9.88931 15.0429 9.89044C14.6852 10.9496 13.6429 11.7107 12.5033 11.8125H12.0836C11.3822 11.7562 10.6999 11.4953 10.1694 11.0441C9.39881 10.4124 8.90381 9.54562 8.30475 8.77387C7.7895 8.09156 7.26412 7.32431 6.41137 7.01438C5.35781 6.63244 4.07137 7.22981 3.68719 8.24456C3.34969 9.08044 3.62419 10.1166 4.37906 10.6521C4.94494 11.0751 5.733 11.2331 6.4125 10.9867C7.16737 10.7235 7.72762 10.125 8.15737 9.4905C8.32669 9.72506 8.4915 9.963 8.65462 10.2026C7.98637 11.0166 7.05938 11.7158 5.95688 11.8125H5.50519C4.11581 11.7191 2.90812 10.5773 2.8125 9.22837V8.78681C2.9025 7.44075 4.095 6.28537 5.4855 6.1875ZM12.0555 6.1875H12.4774C13.8797 6.27581 15.0722 7.44075 15.1875 8.78963V9.4815C14.0304 9.49163 12.8722 9.48488 11.7152 9.486C11.7163 9.2835 11.7163 9.08269 11.7152 8.88019C12.6298 8.87794 13.5433 8.88412 14.4563 8.87794C14.3916 8.52019 14.3077 8.154 14.0884 7.85081C13.554 7.06106 12.4239 6.73819 11.5206 7.08019C10.8006 7.33894 10.2583 7.90481 9.84037 8.50894C9.6795 8.28562 9.51975 8.05894 9.36506 7.83056C10.0249 7.00481 10.9457 6.29044 12.0555 6.1875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAe);
export default __webpack_public_path__ + "static/media/ae.42403d34da31310fbf830d8f2c2f19cb.svg";
export { ForwardRef as ReactComponent };